import Model from '../utils/Model'

class SettlementTypes {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'SettlementTypes'

export const TYPE_BY_TICKET = new SettlementTypes(0, '票结', 'ByTicket')
export const TYPE_MONTHLY = new SettlementTypes(1, '月结', 'Monthly')

export const SETTLEMENT_TYPE = [TYPE_BY_TICKET, TYPE_MONTHLY]

/**
 *  return null:没找到.
 */
export function getClearingTypeByCode(code) {
  return Model.getObjByCode(code, SETTLEMENT_TYPE)
}
